export default __webpack_public_path__ + "static/media/upgreen_transparent.887028aa.png";